import { PromoCard } from '../../../promo-card/PromoCard';
import { getDefaultData } from '../../data/product/get-default-data';
import { ProductLinks } from '../../data/product/product-links';
import { NavigationSubHeaderWithLinks } from '../NavigationSubHeaderWithLinks';
import { FlexColumnContainer } from '../NavigationSubHeaderWithLinks.style';
import {
  HStackContainer,
  LinkText,
  LinkWithArrow,
  NavigationLinkContainer,
} from '../NavigationSubMenu.style';
import { navigation } from '@exploration/cms-constants';
import { Icon, svgIcons } from '@exploration/icons';
import { MDSHStack } from '@midwest/web/stacks';
import { useTheme } from 'styled-components';

export const ProductNavigationSubMenu = () => {
  const cmsData = getDefaultData();
  const { midwestColors: colors } = useTheme();
  return (
    <HStackContainer>
      <NavigationLinkContainer>
        <MDSHStack>
          <FlexColumnContainer>
            <NavigationSubHeaderWithLinks
              header={
                cmsData?.text?.[
                  navigation.products_navigation_links.banking_banking_title
                ]
              }
              links={ProductLinks.bankingLinks}
            />
            <NavigationSubHeaderWithLinks
              header={
                cmsData?.text?.[
                  navigation.products_navigation_links.banking_investments_title
                ]
              }
              links={ProductLinks.investmentLinks}
            />
            <NavigationSubHeaderWithLinks
              header={
                cmsData?.text?.[
                  navigation.products_navigation_links.banking_insurance_title
                ]
              }
              links={ProductLinks.insuranceLinks}
            />
          </FlexColumnContainer>
        </MDSHStack>
        <LinkWithArrow
          key={ProductLinks.bankingNavigationalLink.url}
          href={ProductLinks.bankingNavigationalLink.url}
          target={'_self'}
          aria-label={ProductLinks.bankingNavigationalLink.label}
        >
          <LinkText>{ProductLinks.bankingNavigationalLink.label}</LinkText>
          <Icon
            icon={svgIcons.arrowRight}
            colorPrimary={colors.sentimentNegativeStrong}
            height={19}
            width={19}
          />
        </LinkWithArrow>
      </NavigationLinkContainer>
      <PromoCard
        title={ProductLinks.promoCard.title}
        description={ProductLinks.promoCard.description}
        callToAction={{
          label: ProductLinks.promoCard.callToAction.label,
          url: ProductLinks.promoCard.callToAction.url,
        }}
      />
    </HStackContainer>
  );
};
